import { Fragment } from "react";
import type { IDetailCellRendererParams } from "ag-grid-community";
import { IconArrowRight } from "@synthesis/shared-icons";

import type { ServiceProcessVersion } from "../service-detail-page.lib";

/**
 * Панель раскрытой строки таблицы версий (master/detail AG Grid).
 * Показывает стадии процесса версии и применяемые дороги — таблицей.
 */
export const ServiceVersionDetailPanel = (params: IDetailCellRendererParams<ServiceProcessVersion>) => {
  const version = params.data;

  if (!version) {
    return null;
  }

  return (
    <div className="bg-neutrals-99 flex flex-col gap-5 px-4 py-3">
      <div>
        <p className="subtitle-base text-type-common mb-3">Стадии процесса версии {version.label}</p>
        <ul className="flex flex-wrap items-center gap-2">
          {version.stages.map((step, index) => (
            <Fragment key={step.id}>
              <li className="bg-neutrals-white border-neutrals-95 flex w-60 flex-col gap-1 rounded-xl border p-3 shadow-sm">
                <p className="subtitle-base text-type-common">
                  {step.order} · {step.title}
                </p>
                <p className="subtitle-sm text-additional-blue-50">{step.performer}</p>
                <p className="paragraph-sm text-type-minor">{step.isFinal ? step.duration : `Срок: ${step.duration}`}</p>
              </li>
              {index < version.stages.length - 1 ? (
                <li aria-hidden className="text-neutrals-60 flex size-8 shrink-0 items-center justify-center">
                  <IconArrowRight className="size-5" />
                </li>
              ) : null}
            </Fragment>
          ))}
        </ul>
      </div>

      <div>
        <p className="subtitle-base text-type-common mb-3">Применяется на дорогах:</p>
        <div className="border-neutrals-90 w-full max-w-3xl overflow-hidden rounded-xl border">
          <table className="w-full border-collapse">
            <thead>
              <tr className="bg-neutrals-99">
                <th scope="col" className="subtitle-sm text-type-minor border-neutrals-90 border-b px-4 py-2 text-left font-medium">
                  Дорога
                </th>
                <th scope="col" className="subtitle-sm text-type-minor border-neutrals-90 border-b px-4 py-2 text-left font-medium">
                  Код
                </th>
              </tr>
            </thead>
            <tbody>
              {version.roads.map((road) => (
                <tr key={road.id} className="bg-neutrals-white">
                  <td className="paragraph-sm text-type-common border-neutrals-90 border-b px-4 py-2">{road.name}</td>
                  <td className="paragraph-sm text-type-minor border-neutrals-90 border-b px-4 py-2">{road.code}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};
